export const MAX_AUDIO_BYTES = 200 * 1024 ** 2;
export const MAX_VIDEO_BYTES = 1024 ** 3;
export const mediaLimit = (type: string) => type.startsWith('audio/') ? MAX_AUDIO_BYTES : MAX_VIDEO_BYTES;
export const mediaLimitMessage = (type: string) => type.startsWith('audio/') ? 'Audio files can be up to 200 MB.' : 'Video files can be up to 1 GB.';
export const fits1080p = (width: number, height: number) => width > 0 && height > 0 && Math.max(width, height) <= 1920 && Math.min(width, height) <= 1080;
